import { ConsoleShell, PageHead } from "../components/ConsoleShell.js";
import { EmptyState } from "../components/EmptyState.js";
import { BtnLink } from "../components/Btn.js";
import { Icon } from "../components/Icon.js";

/**
 * Plan & billing — intentionally a placeholder.
 *
 * There is no billing API yet (the Worker exposes only auth / manuals / translations / uploads /
 * media / stores / members — see apps/api/src/index.ts). Per project policy we never fabricate
 * KPI numbers or invoice rows, so this screen keeps the console shell + page head and renders an
 * honest "準備中" state describing what it will surface once subscription/metering endpoints land.
 */
export function Billing() {
  return (
    <ConsoleShell breadcrumb={["TEBIKI", "プラン・課金"]}>
      <PageHead title={<>プラン<span className="hl">・課金</span></>}>
        契約プラン・使用量・請求履歴をまとめて管理します。
      </PageHead>

      <EmptyState
        icon={<Icon name="billing" size={30} />}
        title="プラン・課金は準備中です"
        action={
          <BtnLink to="/members" variant="primary">
            メンバー・権限へ
          </BtnLink>
        }
      >
        契約中のプラン、今月の使用量メーター（AI処理・翻訳・ストレージ・シート）、請求履歴と請求書PDF
        を、課金基盤の接続後にここへ表示します。シート数はメンバー数に連動するため、当面の人数管理は
        「メンバー・権限」から行えます。
      </EmptyState>
    </ConsoleShell>
  );
}
